import { Link } from "react-router-dom";
import styles from "./styles.module.scss";
import {
  ExternalLink,
  FileText,
  Clipboard,
  Users,
  User,
  Folder,
  Mail,
  Settings,
  HelpCircle,
  Info,
} from "feather-icons-react";

export function QuickLinks({ links = [], loading = false }) {
  // Map of icon names to icon components
  const iconMap = {
    "external-link": ExternalLink,
    "file-text": FileText,
    clipboard: Clipboard,
    user: User,
    users: Users,
    folder: Folder,
    mail: Mail,
    settings: Settings,
    "help-circle": HelpCircle,
    info: Info,
  };

  const renderIcon = (iconName) => {
    const IconComponent = iconMap[iconName] || iconMap["external-link"];
    return <IconComponent size={18} />;
  };

  if (loading) {
    return <div className={styles.quickLinksLoading}>Loading quick links...</div>;
  }

  return (
    <div className={styles.quickLinks}>
      {links.map((link) =>
        link.isInternal ? (
          <Link key={link.id} to={link.url} className={styles.quickLink}>
            <div className={styles.icon}>{renderIcon(link.icon)}</div>
            <span>{link.title}</span>
          </Link>
        ) : (
          <a
            key={link.id}
            href={link.url}
            target="_blank"
            rel="noopener noreferrer"
            className={styles.quickLink}
          >
            <div className={styles.icon}>{renderIcon(link.icon)}</div>
            <span>{link.title}</span>
          </a>
        )
      )}
    </div>
  );
}
